import AuthStorage from "../../utils/AuthStorage";
import hasPermission from "../HasPermission";
import usePermission from "../hooks/use-permission";

type useAuthType = {
  routePermissions?: string[];
};

const useAuth = (props: useAuthType) => {
  const { permissions } = usePermission();

  const { routePermissions = [] } = props;

  const isAuthenticated = AuthStorage.getToken().length > 0;
  let isAuthorized = false;
  if (isAuthenticated) {
    if (routePermissions && routePermissions.length) {
      isAuthorized = hasPermission(routePermissions, permissions);
    } else {
      isAuthorized = true;
    }
  }

  return {
    isAuthenticated,
    isAuthorized,
  };
};

export default useAuth;
